export const TFAVerificationEnum = {
    Email: 1,
    Mobile: 2,
    ForgotPassword: 3,
    ChangePassword: 4,
    ForgotPasswordFinal: 5,
    PlayerLockoutReset: 6,
    ForgotUserName: 7,
    DormantActivate: 8,
    AccountClosure: 9,
    AccountInfo: 10
}
